export default __webpack_public_path__ + "static/media/home3.9330ba01.jpg";